import dayjs from "dayjs";

export const sortStringValues = (a?: string | null, b?: string | null) =>
  (a ? a.toLowerCase() : "").localeCompare(b ? b.toLowerCase() : "", undefined, { numeric: true });

// Missing values (null, undefined, NaN) are ordered before any number
export const sortNumberValues = (a?: number | null, b?: number | null) => {
  const valueA = typeof a === "number" && !Number.isNaN(a) ? a : Number.NEGATIVE_INFINITY;
  const valueB = typeof b === "number" && !Number.isNaN(b) ? b : Number.NEGATIVE_INFINITY;
  if (valueA === valueB) {
    return 0;
  }
  return valueA > valueB ? 1 : -1;
};

export const sortDateValues = (a?: string | null, b?: string | null): number => {
  const dateA = a ? dayjs(a).valueOf() : 0;
  const dateB = b ? dayjs(b).valueOf() : 0;
  return dateA - dateB;
};
